export const removeTrailingSlash = (url = '') => {
  const queryStart = url.search(/[?#]/);
  const path = queryStart === -1 ? url : url.slice(0, queryStart);
  const pathWithoutTrailingSlash = path.replace(/\/+$/, '') || path.slice(0, 1);

  return `${pathWithoutTrailingSlash}${url.slice(path.length)}`;
};
